// @flow
import * as React from 'react';
import { point12Messages } from 'esm-web-pro/messages/points12Messages';
import NoFormSelect from 'esm-web-pro/components/forms/fields/NoFormSelect';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';


type Props = {
    PoPLayers12: {[string]: Object},
    value: ?string,
    onChange: Function,

    intl: IntlShape,
};

const Point12Select = (props: Props) => {
    const {
        PoPLayers12, value, onChange, intl: { formatMessage },
    } = props;

    const choices = {};

    Object.keys(PoPLayers12).forEach((key) => {
        const pointName = PoPLayers12[key].type === 'switch'
            ? PoPLayers12[key].oss_switch_name
            : `${formatMessage(point12Messages[PoPLayers12[key].type])} ${PoPLayers12[key].sequence}`;

        if (PoPLayers12[key].rack) {
            choices[key] = `${formatMessage(point12Messages.rack)} ${PoPLayers12[key].rack.sequence} - ${pointName}`;
        } else {
            choices[key] = pointName;
        }
    });

    return (
        <NoFormSelect
            label={(
                <FormattedMessage id="odf-port-connect-point-select" defaultMessage="Choose a point" />
            )}
            choices={choices}
            value={value}
            onChange={onChange}
            required
        />
    );
};

export default injectIntl(Point12Select);
